import React from "react";

const Optizmo = () => {
  React.useEffect(() => {
    window.open("https://app.optizmo.com/auth/login", "_blank");
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>Redirecting to Optizmo...</h2>
      <p>
        If the window didn't open automatically,{" "}
        <a 
          href="https://app.optizmo.com/auth/login" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          click here
        </a>
      </p>
    </div>
  );
};

export default Optizmo;